import type { GenericPointGeometry, LngLat } from '@yandex/ymaps3-types';
import React from 'react';
import { loadModulePromise } from 'src/components/YandexMap/mapLoader';
import { loadReactComponent } from 'src/components/YandexMap/loaders/componentLoaders';
import styled, { keyframes } from 'styled-components';
import type { Coordinates } from '@lt/api/dist/types/map';

const YMapMarker = loadReactComponent('YMapMarker', loadModulePromise);

type ClusterPointProps = GenericPointGeometry<LngLat> & {
  hotelCount: number;
  moveToPoint: (
    coordinates: Coordinates,
    zoomDiff: number,
    offset: { x: number; y: number },
  ) => void;
};

const ClusterPoint = (props: ClusterPointProps) => {
  const { hotelCount, moveToPoint } = props;

  const handleClick = () => {
    const { coordinates } = props;
    moveToPoint(coordinates as Coordinates, 3, { x: 0, y: 0 });
  };

  return (
    <YMapMarker onClick={handleClick} {...props} hideOutsideViewport>
      <StyledClusterPoint>{hotelCount}</StyledClusterPoint>
    </YMapMarker>
  );
};

const fadeIn = keyframes`
  from {
      opacity: 0;
  }
  to {
      opacity: 1;
  }
`;

const StyledClusterPoint = styled.div`
  cursor: pointer;
  border: 1px solid #007aff;
  background: #fff;
  border-radius: 12px;
  padding: 4px 8px;
  color: #007aff;
  font-weight: 700;
  font-size: 12px;
  animation: ${fadeIn} 0.25s ease;
`;

export default ClusterPoint;
